module.exports = __webpack_public_path__ + "static/media/Celeb3.6ba1c9c9.jpg";